const resources = {
    ctaApply: 'Apply',
    ctaApplied: 'Applied',
    ctaRemove: 'Remove',
    ctaUrl: 'Shop Now',
    ctaAppOnly: 'App Exclusive',
    ctaStoreOnly: 'In Store Only',
    seeDetails: 'See details',
    insider: 'Rouge, VIB, and Insider members only.',
    vib: 'Rouge and VIB members only.',
    rouge: 'Rouge members only.',
    ends: 'Ends',
    appOnly: 'App only',
    onlineOnly: 'Online only',
    storeOnly: 'In store only',
    inStoreAndOnline: 'In store & Online'
};

module.exports = function getResource(label) {
    return resources[label];
};
